import React from "react";
import { CheckIcon, TargetIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { volumes } from "../data/content";
export function Volumes() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" data-id="element-339" data-mp="185gd67h8c4pq">
      <div className="mx-auto max-w-4xl" data-id="element-340" data-mp="1c4yz96kselu5">
        <SectionHeading eyebrow="What's inside Insulin Resistance Nutrition Blueprint™?" title="Six Practical Clinical Volumes" subtitle="For a more structured approach to insulin resistance nutrition care." data-id="element-341" data-mp="1c60cnhp9zkf1" />

        <div className="mt-10 space-y-6" data-id="element-342" data-mp="1qumwnwpul0cl">
          {volumes.map(volume => <article key={volume.numeral} className="overflow-hidden rounded-2xl bg-white shadow-[0_6px_24px_-12px_rgba(11,31,58,0.25)]" data-id="element-343" data-mp="1vtg1z1uzdl1o">
              <div className="bg-navy px-5 py-5 sm:px-8" data-id="element-344" data-mp="fe6g202k4do5">
                <span className="inline-block rounded-md bg-gold px-2.5 py-1 text-xs font-black uppercase tracking-wider text-navy" data-id="element-345" data-mp="keaxptf7befy">
                  Volume {volume.numeral}
                </span>
                <h3 className="mt-3 font-serif text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-346" data-mp="3j93gkpgmfhzk">{volume.title}</h3>
                <p className="mt-2 text-[15px] font-semibold text-gold sm:text-base" data-id="element-347" data-mp="21hv2fg1bplb">{volume.subtitle}</p>
              </div>

              <div className="px-5 py-6 sm:px-8" data-id="element-348" data-mp="3t6giqq1vyyvs">
                <div className="space-y-3 text-[16px] leading-relaxed text-muted" data-id="element-349" data-mp="b1n22ohbglyy">
                  {volume.intro.map(p => <p key={p} data-id="element-350" data-mp="63bpw73jtzdk">{p}</p>)}
                </div>

                <p className="mt-6 text-sm font-bold uppercase tracking-wider text-navy" data-id="element-351" data-mp="kr6kjt14adta">Inside, you'll find:</p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2 sm:gap-x-6" data-id="element-352" data-mp="fs3eq6dbc3k9">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-ink" data-id="element-353" data-mp="tsxn4p0d24ix">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-354" data-mp="ps3ytuj0anpi" />
                      {item}
                    </li>)}
                </ul>

                <div className="mt-6 flex gap-3 rounded-xl bg-gold-light p-4" data-id="element-355" data-mp="11t3shqqbso50">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-356" data-mp="16r5ae8c0mhew" />
                  <p className="text-[15px] leading-relaxed text-ink" data-id="element-357" data-mp="1bk6qukrvep0l">
                    <strong data-id="element-358" data-mp="1fl0c16dxhpps">The objective:</strong> {volume.objective}
                  </p>
                </div>

                <p className="mt-4 text-[13px] italic leading-relaxed text-muted" data-id="element-359" data-mp="1kia8h5zqj1n4">{volume.disclaimer}</p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-14 max-w-2xl text-center" data-id="element-360" data-mp="1ui179jvbw2t0">
          <h3 className="font-serif text-[28px] font-bold leading-tight text-navy sm:text-4xl" data-id="element-361" data-mp="1ufeyxi0m5j9q">
            Six volumes. One organized nutrition care system.
          </h3>
          <p className="mt-4 text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-362" data-mp="49sk5y56sqp">
            Rather than searching through scattered notes and repeatedly rebuilding your own resources, you'll be able to
            navigate directly to the topic you need to review.
          </p>
          <p className="mt-4 text-[17px] font-semibold leading-relaxed text-ink sm:text-lg" data-id="element-363" data-mp="24mhmcb0zhfvr">
            Each volume has a defined purpose. Each worksheet supports a specific organizational task. And the visual framework
            connects every part of the system.
          </p>
        </div>

        <div className="mt-10" data-id="element-364" data-mp="2sar3gzn95fgk">
          <CTAButton label="Yes, I want all six volumes" note="Instant Digital Access · One-Time Payment of $27 USD" data-id="element-365" data-mp="2sbsej449q1ya" />
        </div>
      </div>
    </section>;
}